import { z } from 'zod/v4';

/**
 * A per-device position grid narrower than {@link import('./widget-position').widgetPositionSchemaLegacy}
 * (button's "simple" grid): no `tabletWidth`/`tabletX`/`tabletY`/`tabletRotate`/`tabletZIndex`, and
 * no `mobileWidth` either. First identified on `menu` — `menu-widget.type.ts`'s
 * `MenuWidgetData['position']` genuinely has only these nine fields, even though
 * `MenuControlComponent`'s FormGroup declares the missing tablet controls anyway (dead code:
 * nothing in the type or the persisted shape reads them). `accordion` turned out to have the
 * byte-identical shape (same dead tablet controls in its own control FormGroup too) — promoted
 * here the moment a second widget needed it, rather than duplicating a third time.
 */
export const narrowWidgetPositionSchemaLegacy = z.object({
    width: z.number().nullish(),
    x: z.number().nullish(),
    y: z.number().nullish(),
    rotate: z.number().nullish(),
    zIndex: z.number().nullish(),
    mobileX: z.number().nullish(),
    mobileY: z.number().nullish(),
    mobileRotate: z.number().nullish(),
    mobileZIndex: z.number().nullish(),
});

export type NarrowWidgetPositionLegacy = z.infer<typeof narrowWidgetPositionSchemaLegacy>;

/** Shape fragment for widget data schemas — spread into the data `z.object()`. */
export const narrowWidgetPositionPluginShapeLegacy = {
    position: narrowWidgetPositionSchemaLegacy.nullish(),
} as const;

/** Default position bag — mirrors both `menu.model.ts`'s and `accordion.model.ts`'s defaults verbatim. */
export const createNarrowWidgetPositionLegacy = (
    overrides: Partial<NarrowWidgetPositionLegacy> = {}
): NarrowWidgetPositionLegacy => ({
    width: 100,
    x: 0,
    y: 0,
    rotate: 0,
    zIndex: 0,
    mobileX: 0,
    mobileY: 0,
    mobileRotate: 0,
    mobileZIndex: 0,
    ...overrides,
});
